<template>
    <button class="mdc-button__icon-single button-close">
        <span class="mdc-button__icon material-symbols-outlined">close</span>
    </button>
</template>

<script>
export default {
    name: "button-close"
}
</script>

<style lang="scss">
@use "../scss/design-library/functions/calculate";
@use "../scss/design-library/colors";

.button-close {
    --mdc-text-button-with-icon-icon-size: #{calculate.rem(40)};
    --mdc-theme-primary: #{colors.$anthrazit};
}
</style>
